var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle09(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#70d09d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.563,9.563a9,9,0,1,1-9-9A9,9,0,0,1,18.563,9.563ZM8.521,14.328,15.2,7.651a.581.581,0,0,0,0-.821l-.821-.821a.581.581,0,0,0-.821,0L8.111,11.454,5.568,8.911a.581.581,0,0,0-.821,0l-.821.821a.581.581,0,0,0,0,.821L7.7,14.328a.581.581,0,0,0,.821,0Z",
    transform: "translate(-0.563 -0.563)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle09);
export default __webpack_public_path__ + "static/media/check-circle-09.091c6b8f773226abade6260f3907aa82.svg";
export { ForwardRef as ReactComponent };